import React from "react";
import "./GrowbooWorks.css"; // Make sure to create this CSS file

const GrowbooWorks = () => {
  return (
    <div className="growbooworks-container">
      <h1>How Grow Bizint International Works</h1>
      <div className="steps-wrapper">
        <div className="step-item">
          <div className="icon-circle">
            <span className="icon">👤</span>{" "}
            {/* You might want to replace this with an actual icon library icon */}
          </div>
          <p>Create an Account</p>
        </div>
        <div className="step-item">
          <div className="icon-circle">
            <span className="icon">🌱</span>{" "}
            {/* You might want to replace this with an actual icon library icon */}
          </div>
          <p>Deposit</p>
        </div>
        <div className="step-item">
          <div className="icon-circle">
            <span className="icon">💰</span>{" "}
            {/* You might want to replace this with an actual icon library icon */}
          </div>
          <p>Get Profit</p>
        </div>
      </div>
    </div>
  );
};

export default GrowbooWorks;
